module.exports = "<p>לאחר שהתחברתם לאתר, תוכלו ללחוץ על לחצן החשבון שבחלקו העליון של עמוד הבית ולבחור בניהול נכסים. לחצו על הלחצן &quot;פעיל&quot;, והופ! המודעה מיד תהפוך ללא פעילה.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/6.md
// module id = 819
// module chunks = 0